// extracted by mini-css-extract-plugin
module.exports =  {"phone":"_32bbee5fda--phone--IDdhZ","hoverText":"_32bbee5fda--hoverText--WxdFz","simplified-phone":"_32bbee5fda--simplified-phone--MKcPG"};